import { accountingRoutePaths, accountingRoutes } from 'src/accounting/routes';
import { aiRoutePaths, aiRoutes } from 'src/ai/routes';

import type { AppRoute } from './types';

import {
  arrangementRoutePaths,
  arrangementRoutes,
} from '../arrangement/routes';
import { careRoutePaths, careRoutes } from '../care/routes';
import { deviationRoutePaths, deviationRoutes } from '../deviation/routes';
import {
  implementationRoutePaths,
  implementationRoutes,
} from '../implementation/routes';
import {
  organizationRoutePaths,
  organizationRoutes,
} from '../organization/routes';
import { getPrivatePath } from './get-private-path';
import { guardRoute } from './guard-route';

const routes = [
  ...aiRoutes,
  ...deviationRoutes,
  ...organizationRoutes,
  ...careRoutes,
  ...implementationRoutes,
  ...arrangementRoutes,
  ...accountingRoutes,
];

const routePaths = {
  ...aiRoutePaths,
  ...deviationRoutePaths,
  ...organizationRoutePaths,
  ...careRoutePaths,
  ...implementationRoutePaths,
  ...arrangementRoutePaths,
  ...accountingRoutePaths,
};

export const { privateAppRoutes, publicAppRoutes } = routes
  .filter((route) => route.enabled)
  .map(guardRoute)
  .reduce(
    (acc, route) => {
      if (route.scope === 'private') {
        const privatePath = getPrivatePath(route.path);
        acc.privateAppRoutes.push({ ...route, path: privatePath });
      } else {
        acc.publicAppRoutes.push(route);
      }
      return acc;
    },
    { privateAppRoutes: [] as AppRoute[], publicAppRoutes: [] as AppRoute[] }
  );

type AppRoutePaths = {
  [K in keyof typeof routePaths]: (typeof routePaths)[K];
};

export const appRoutePaths = Object.entries(routePaths).reduce(
  (acc, [key, value]) => {
    const isPrivate = routes.some(
      (route) => route.scope === 'private' && route.path === value
    );
    return { ...acc, [key]: isPrivate ? getPrivatePath(value) : value };
  },
  {} as AppRoutePaths
);
